import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, UtensilsIcon, ListChecksIcon, HeartPulseIcon } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: <UtensilsIcon className="w-6 h-6" data-id="element-173" />,
    title: 'Recetas Reales',
    desc: 'Comidas ricas y fáciles de preparar que cuidan tu hígado sin sentir que estás a dieta.'
  }, {
    icon: <ListChecksIcon className="w-6 h-6" data-id="element-174" />,
    title: 'Menú de 7 Días',
    desc: 'Un plan organizado para que sepas exactamente qué desayunar, almorzar y cenar.'
  }, {
    icon: <BookOpenIcon className="w-6 h-6" data-id="element-175" />,
    title: 'Guía de Reemplazos',
    desc: 'Aprendé a sustituir ingredientes inflamatorios por opciones saludables y deliciosas.'
  }, {
    icon: <HeartPulseIcon className="w-6 h-6" data-id="element-176" />,
    title: 'Tranquilidad Mental',
    desc: 'Dejá de dudar en cada comida y recuperá el control de tu salud y tus análisis.'
  }];
  return <section className="py-24 bg-brand-900 text-white relative overflow-hidden" data-id="element-177">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-178">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-brand-400 blur-3xl" data-id="element-179"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-brand-500 blur-3xl" data-id="element-180"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-181">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-182">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold mb-6" data-id="element-183">
            Por eso creamos{' '}
            <span className="text-brand-300" data-id="element-184">Chau Hígado Graso.</span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-brand-100 leading-relaxed mb-8" data-id="element-185">
            Una guía digital pensada para ayudarte a dejar de improvisar y
            empezar a comer con más claridad, tranquilidad y control.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="inline-flex flex-col sm:flex-row items-center justify-center gap-4 text-brand-200 font-medium bg-brand-800/50 p-4 rounded-2xl border border-brand-700/50" data-id="element-186">
            <span className="flex items-center gap-2" data-id="element-187">
              <span className="text-accent-400" data-id="element-188">✕</span> No es una dieta
              extrema.
            </span>
            <span className="hidden sm:inline text-brand-600" data-id="element-189">•</span>
            <span className="flex items-center gap-2" data-id="element-190">
              <span className="text-accent-400" data-id="element-191">✕</span> No son prohibiciones.
            </span>
            <span className="hidden sm:inline text-brand-600" data-id="element-192">•</span>
            <span className="flex items-center gap-2" data-id="element-193">
              <span className="text-accent-400" data-id="element-194">✕</span> No es info confusa.
            </span>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-195">
          {features.map((feature, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-brand-800/40 border border-brand-700/50 p-8 rounded-2xl hover:bg-brand-800/60 transition-colors" data-id="element-196">
              <div className="w-12 h-12 bg-brand-600 rounded-xl flex items-center justify-center text-white mb-6 shadow-lg" data-id="element-197">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold mb-3 text-white" data-id="element-198">
                {feature.title}
              </h3>
              <p className="text-brand-200 leading-relaxed" data-id="element-199">{feature.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}